module.exports = __webpack_public_path__ + "symantec@2x.5af64e1bf8f2e3fe86925637e10ab8c3.png";